import React from 'react';

const SectionTitle = ({ children }) => {
  return (
    <h2 className="text-6xl text-center font-title py-5 text-gray-800 mb-4">{children}</h2>
  );
};

export default SectionTitle;
